import { ContractPolicy, OrganizationType } from "@meditect/medibase-api-client";

export const formatContractPolicyTitle = (policy: ContractPolicy): string => {
  const isBeneficiary = policy?.beneficiaryId !== policy?.contract?.owner?.id;
  const title =
    policy.contract.insurer.type !== OrganizationType.SOCIAL_SECURITY
      ? `${policy?.contract.insurer.name} (${isBeneficiary ? "par relation" : "directe"}) - ${(policy?.contractPolicyTags ?? []).length > 0 ? "Couverture par catégories" : `${policy?.coverage}%`}`
      : `${policy?.contract.insurer.name} (${isBeneficiary ? "par relation" : "directe"})`;

  return title;
};
